module.exports = __webpack_public_path__ + "static/media/closemark.4f7b8bd8.svg";